import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeComponent } from 'angularx-qrcode';
import { HighchartsChartComponent } from 'highcharts-angular';
import { MaterialModule } from '../material/material.module';
import { AutoCompleteComponent } from './_components/auto-complete/auto-complete.component';
import { BarChartComponent } from './_components/bar-chart/bar-chart.component';
import { BreadcrumbComponent } from './_components/breadcrumb/breadcrumb.component';
import { BubbleChartComponent } from './_components/bubble-chart/bubble-chart.component';
import { ButtonToggleComponent } from './_components/button-toggle/button-toggle.component';
import { ButtonComponent } from './_components/button/button.component';
import { CardComponent } from './_components/card/card.component';
import { ChangeGeolovelChipComponent } from './_components/change-geolovel-chip/change-geolovel-chip.component';
import { CheckboxComponent } from './_components/checkbox/checkbox.component';
import { ConfirmationBoxComponent } from './_components/confirmation-box/confirmation-box.component';
import { DatePickerComponent } from './_components/date-picker/date-picker.component';
import { DateRangePickerComponent } from './_components/date-range-picker/date-range-picker.component';
import { DoughnutChartDashboardComponent } from './_components/doughnut-chart-dashboard/doughnut-chart-dashboard.component';
import { DoughnutChartComponent } from './_components/doughnut-chart/doughnut-chart.component';
import { FabButtonComponent } from './_components/fab-button/fab-button.component';
import { FileComponent } from './_components/file/file.component';
import { FilterChipComponent } from './_components/filter-chip/filter-chip.component';
import { FinancialHomeComponent } from './_components/financial-home/financial-home.component';
import { GlobalHeaderComponent } from './_components/global-header/global-header.component';
import { HeaderComponent } from './_components/header/header.component';
import { InputComponent } from './_components/input/input.component';
import { LabelComponent } from './_components/label/label.component';
import { LineChartComponent } from './_components/line-chart/line-chart.component';
import { MasterChartComponent } from './_components/master-chart/master-chart.component';
import { MemberIDCardComponent } from './_components/member-id-card/member-id-card.component';
import { MenuItemComponent } from './_components/menu-item/menu-item.component';
import { PageHeaderComponent } from './_components/page-header/page-header.component';
import { PageNotFoundComponent } from './_components/page-not-found/page-not-found.component';
import { PaginationComponent } from './_components/pagination/pagination.component';
import { PercentageChartComponent } from './_components/percentage-chart/percentage-chart.component';
import { ProfileComponent } from './_components/profile/profile.component';
import { ProgressComponent } from './_components/progress/progress.component';
import { RadialBarChartComponent } from './_components/radial-bar-chart/radial-bar-chart.component';
import { RadioComponent } from './_components/radio/radio.component';
import { ReferenceDialogComponent } from './_components/reference-dialog/reference-dialog.component';
import { RefreshButtonComponent } from './_components/refresh-button/refresh-button.component';
import { RegistrationCertificateComponent } from './_components/registration-certificate/registration-certificate.component';
import { RejectBoxComponent } from './_components/reject-box/reject-box.component';
import { ResolutionCopyComponent } from './_components/resolution-copy/resolution-copy.component';
import { RoleNotFoundComponent } from './_components/role-not-found/role-not-found.component';
import { RoleRequestComponent } from './_components/role-request/role-request.component';
import { SelectComponent } from './_components/select/select.component';
import { ServerErrorComponent } from './_components/server-error/server-error.component';
import { SideMenuComponent } from './_components/side-menu/side-menu.component';
import { SnackbarComponent } from './_components/snackbar/snackbar.component';
import { CustomActionComponent } from './_components/table/_component/custom-action/custom-action.component';
import { CustomColumnComponent } from './_components/table/_component/custom-column/custom-column.component';
import { TableComponent } from './_components/table/table.component';
import { TextAreaComponent } from './_components/text-area/text-area.component';
import { ToggleComponent } from './_components/toggle/toggle.component';
import { UnauthorisedAccessPageComponent } from './_components/unauthorised-access-page/unauthorised-access-page.component';
import { NoScriptTagDirective } from './_directives/no-script-tag.directive';
import { PositiveIntegerDirective } from './_directives/positive-integer.directive';
import { CroreFormatPipe } from './_pipes/crore-format.pipe';
import { IndianCurrencyPipe } from './_pipes/indian-currency.pipe';
import { IndianFormatPipe } from './_pipes/indian-format.pipe';
import { NumberFormatPipe } from './_pipes/number-format.pipe';
import { NumberToWordPipe } from './_pipes/number-to-word.pipe';
import { LakhAmountPipe } from './_pipes/lakh-amount.pipe';

const EXPORTED_COMPONENTS = [
    AutoCompleteComponent,
    BarChartComponent,
    BreadcrumbComponent,
    BubbleChartComponent,
    ButtonComponent,
    ButtonToggleComponent,
    CardComponent,
    ChangeGeolovelChipComponent,
    CheckboxComponent,
    ConfirmationBoxComponent,
    CroreFormatPipe,
    CustomActionComponent,
    CustomColumnComponent,
    DatePickerComponent,
    DateRangePickerComponent,
    DoughnutChartComponent,
    DoughnutChartDashboardComponent,
    FabButtonComponent,
    FileComponent,
    FilterChipComponent,
    FinancialHomeComponent,
    GlobalHeaderComponent,
    HeaderComponent,
    IndianCurrencyPipe,
    IndianFormatPipe,
    InputComponent,
    LabelComponent,
    LineChartComponent,
    MasterChartComponent,
    MenuItemComponent,
    NoScriptTagDirective,
    NumberFormatPipe,
    NumberToWordPipe,
    LakhAmountPipe,
    PageHeaderComponent,
    PageNotFoundComponent,
    PaginationComponent,
    PercentageChartComponent,
    PositiveIntegerDirective,
    ProfileComponent,
    RadialBarChartComponent,
    RadioComponent,
    ReferenceDialogComponent,
    RefreshButtonComponent,
    RejectBoxComponent,
    RoleNotFoundComponent,
    RoleRequestComponent,
    SelectComponent,
    ServerErrorComponent,
    SideMenuComponent,
    SnackbarComponent,
    TableComponent,
    TextAreaComponent,
    ToggleComponent,
    UnauthorisedAccessPageComponent,
    RegistrationCertificateComponent,
    ResolutionCopyComponent,
    MemberIDCardComponent,
    DoughnutChartComponent,
    ProgressComponent,
];

const EXPORTED_MODULES = [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    HttpClientModule,
    MaterialModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    QRCodeComponent,
    HighchartsChartComponent,
];

@NgModule({
    declarations: [...EXPORTED_COMPONENTS, RefreshButtonComponent],
    imports: [...EXPORTED_MODULES],
    exports: [...EXPORTED_COMPONENTS, ...EXPORTED_MODULES],
})
export class SharedModule {}
